import React from 'react';
import '../Welcomes/Welcome.css';

const Welcome = () => {
  return (
    <div className="welcome d-flex align-items-center justify-content-center text-center">
      <h2 className="welcome-heading">
        WELCOME TO NORTH POINT CHILDREN'S ACADEMY
      </h2>
    </div>
  );
};

export default Welcome;